var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { Button, FormField, Input, InputList, Modal } from '../../shared';
import { useForm } from 'react-hook-form';
import { defaultErrorResponse, hasError } from '../../../shared/types/service-handling';
import './worldpay.scss';
import { services } from '../../../shared';
export var worldPaySubmitInitialState = {
    data: undefined,
    loading: false,
    error: false,
};
export var WorldPay = function (_a) {
    var handleClose = _a.handleClose, show = _a.show, fees = _a.fees, reloadGrids = _a.reloadGrids, caseId = _a.caseId, formId = _a.formId;
    var _b = useState(''), worldPayError = _b[0], setWorldPayError = _b[1];
    var _c = useState(null), worldPayWindow = _c[0], setWorldPayWindow = _c[1];
    var _d = useState(null), connection = _d[0], setConnection = _d[1];
    var _e = useState(worldPaySubmitInitialState), shWorldPaySubmit = _e[0], setShWorldPaySubmit = _e[1];
    var _f = useForm(), register = _f.register, handleSubmit = _f.handleSubmit, setValue = _f.setValue, errors = _f.errors;
    var countries = [
        {
            id: -1,
            value: 'GB',
            code: 'GB',
            displayText: 'United Kingdom',
        },
        {
            id: -2,
            value: 'US',
            code: 'US',
            displayText: 'United States',
        },
    ];
    var validation = {
        emailAddress: {
            types: { required: true, pattern: /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/ },
            message: "Please enter an email address",
        },
        addressLine1: {
            types: { required: true },
            message: "Please enter a billing address",
        },
        city: {
            types: { required: true },
            message: "Please enter a city",
        },
        postcode: {
            types: { required: true },
            message: "Please enter a postcode",
        },
        countryCode: {
            types: { required: true },
            message: "Please enter a country",
        },
        reference: {
            types: { required: true },
            message: "Please enter a reference",
        },
    };
    var startCheckingForPaymentStatus = function (worldPayOrder) { return __awaiter(void 0, void 0, void 0, function () {
        var response, newConnection;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setShWorldPaySubmit(__assign(__assign({}, shWorldPaySubmit), { loading: true }));
                    return [4 /*yield*/, services.submitWorldPayOrder(caseId, formId, worldPayOrder)];
                case 1:
                    response = _b.sent();
                    setShWorldPaySubmit(response);
                    if (response.data && response.data.isOrderSucceeded && ((_a = response.data.redirectionUrl) !== null && _a !== void 0 ? _a : '').length > 0) {
                        newConnection = services.getHubConnection();
                        setConnection(newConnection);
                    }
                    return [2 /*return*/, response.data.isOrderSucceeded ? response.data.redirectionUrl : ''];
            }
        });
    }); };
    var sendToWorldPay = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var worldPayOrder, redirectUrl, wpw;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    worldPayOrder = {
                        emailAddress: data.emailAddress,
                        addressLine1: data.addressLine1,
                        city: data.city,
                        postcode: data.postcode,
                        countryCode: (_b = (_a = countries === null || countries === void 0 ? void 0 : countries.find(function (country) { return (country === null || country === void 0 ? void 0 : country.id) == data.countryCode; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 'GB',
                        reference: data.reference,
                        fees: fees,
                        amount: fees.map(function (fee) { return fee.amount; }).reduce(function (acc, next) { return (acc !== null && acc !== void 0 ? acc : 0) + next; }),
                    };
                    return [4 /*yield*/, startCheckingForPaymentStatus(worldPayOrder)];
                case 1:
                    redirectUrl = _c.sent();
                    if ((redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : '').length > 0) {
                        wpw = window.open("/worldpay/?".concat(redirectUrl), '_blank');
                        setWorldPayWindow(wpw);
                        setWorldPayError('Processing worldpay payment...');
                    }
                    else {
                        setWorldPayError('Payment could not be processed');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (connection) {
            connection.start().then(function () {
                connection.invoke('getConnectionId').then(function (connectionId) {
                    // Send the connectionId to controller
                });
                connection.on('paymentProcessed', function (message) {
                    if (worldPayWindow !== null) {
                        worldPayWindow.close();
                    }
                    reloadGrids(caseId, formId);
                    handleClose();
                    connection.stop();
                });
            });
        }
    }, [connection]);
    if (hasError([shWorldPaySubmit])) {
        return defaultErrorResponse();
    }
    return (React.createElement(Modal, { title: "Client Contact Details", show: show, handleClose: handleClose, extendClass: "worldpay" },
        React.createElement("form", { onSubmit: handleSubmit(sendToWorldPay) },
            worldPayError && (React.createElement("p", { role: "alert", className: "c-form-field__error" }, worldPayError)),
            React.createElement(FormField, { label: "Email Address", error: errors.emailAddress && validation.emailAddress.message },
                React.createElement(Input, { id: "emailAddress", placeHolder: "Email address", error: !!errors.emailAddress, ref: register(validation.emailAddress.types) })),
            React.createElement(FormField, { label: "Address Line 1", error: errors.addressLine1 && validation.addressLine1.message },
                React.createElement(Input, { id: "addressLine1", placeHolder: "Address Line 1", error: !!errors.addressLine1, ref: register(validation.addressLine1.types) })),
            React.createElement(FormField, { label: "City", error: errors.city && validation.city.message },
                React.createElement(Input, { id: "city", placeHolder: "City", error: !!errors.city, ref: register(validation.city.types) })),
            React.createElement(FormField, { label: "Postcode", error: errors.postcode && validation.postcode.message },
                React.createElement(Input, { id: "postcode", placeHolder: "Postcode", error: !!errors.postcode, ref: register(validation.postcode.types) })),
            React.createElement(FormField, { label: "Country", error: errors.countryCode && validation.countryCode.message },
                React.createElement(InputList, { id: "countryCode", options: countries, legend: "Select a country", forceSelection: true, error: !!errors.countryCode, ref: register(validation.countryCode.types) })),
            React.createElement(FormField, { label: "Reference", error: errors.reference && validation.reference.message },
                React.createElement(Input, { id: "reference", placeHolder: "Reference", error: !!errors.reference, ref: register(validation.reference.types) })),
            React.createElement(Button, { type: "button", variant: "navy", size: "small", onClick: handleClose }, "Cancel"),
            React.createElement(Button, { type: "submit", childClasses: "pay-button", variant: "primary", size: "small" }, "Pay"))));
};
